module.exports = __webpack_public_path__ + "static/media/lupe.7ddc0682.jpg";